{
    "filter_menu_title__status": "Status",
    "filter_menu_title__order_date": "Order date",
    "filter_menu_title__quote_date": "Quote date",
    "filter_menu_title__clerk": "Created by",
    "filter_menu_title__order_type": "Order Type",
    "filter_menu_title__quote_type": "Quote Type",
    "filter_menu_title__sales_rep": "Sales Representative",
    "filter_menu_title__location": "Storage Location",
    "filter_menu_title__total_amount_net": "Total",
    "filter_menu_title__total_margin": "Gross margin",
    "table_header__product_name": "Product",
    "table_header__quote_id": "Quote no.",
    "table_header__order_id": "Order no.",
    "table_header__quote": "Quote",
    "table_header__order": "Order",
    "table_header__quote_type": "Quote Type",
    "table_header__order_type": "Order Type",
    "table_header__customer_id": "Customer no.",
    "table_header__quote_created": "Date",
    "table_header__order_created": "Date",
    "table_header__status": "Status",
    "table_header__customer": "Customer",
    "table_header__total": "Total",
    "table_header__rebate": "Rebate",
    "table_header__margin": "GM",
    "table_header__margin_percent": "GM %",
    "table_header__lines": "Lines",
    "table_header__quantity": "Quantity",
    "table_header__quantity_short": "Quantity",
    "table_header__price": "Price",
    "table_header__clerk": "Clerk",
    "table_header__po_number": "PO Number",
    "search_placeholder__orders": "Search by customer, order, PO number",
    "search_placeholder__quotes": "Search by customer, quote, PO number",
    "table_footer__sum": "Sum"
}
